import { type MCPServerInfo } from '../../types';

const MockServer: MCPServerInfo = {
  serverId: 'MOCK_SERVER',
  name: 'Mock Server',
  slug: 'mock-server',
  description:
    'No-auth mock MCP server with fast and slow tools for load testing the MCP broker pipeline.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'NATOMA',
    repositoryUrl: 'https://github.com/natomalabs/mock-mcp-server',
    commitSha: 'd84a6346',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'NONE',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default MockServer;
